import script from "./CreateSpecialApproval.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateSpecialApproval.vue?vue&type=script&setup=true&lang=js"

import "./CreateSpecialApproval.vue?vue&type=style&index=0&id=16e21f0e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16e21f0e"]])

export default __exports__